import Notification from "components/Notification";
import PropTypes from "prop-types";

export const authNotificationCodes = new Set([
    "expiredJWT",
    "invalidJWT",
    "missingJWT",
    "authenticationFailure",
    "authenticationWithThirdPartyFailure",
    "userNotFound",
    "forgotPassword.emailSent",
    "forgotPassword.userNotFound",
    "forgotPassword.emailSendError",
    "confirmForgotPassword.passwordChanged",
    "confirmForgotPassword.notFound",
    "confirmForgotPassword.expiredResetToken",
    "confirmForgotPassword.validationError",
    "account.create.successful",
    "account.create.emailSent",
    "account.create.expiredResetToken",
    "account.create.emailVerify.successful",
    "account.create.emailVerify.failed",
    "account.create.company.successful",
    "account.create.company.failed",
]);

/**
 * Notification Manager - Auth Notifications
 * @return {Node} Returns Notification component
 */
const AuthNotifications = ({ identifier, code }) => {
    switch (code) {
        case "expiredJWT":
            return (
                <Notification
                    identifier={identifier}
                    title="Please Sign In!"
                    text="Sorry, your session expired."
                    type="warning"
                />
            );
        case "invalidJWT":
            return (
                <Notification
                    identifier={identifier}
                    title="Please Sign In!"
                    text="Sorry, your session expired."
                    type="warning"
                />
            );
        case "missingJWT":
            return null;

        // Sign In
        case "authenticationFailure":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="Invalid username or wrong password. Please try again."
                    type="error"
                />
            );
        case "authenticationWithThirdPartyFailure":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="There was a problem with a third party authentication."
                    type="error"
                />
            );
        case "userNotFound":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="User cannot be found using provided email address!"
                    type="error"
                />
            );

        // Forgot Password
        case "forgotPassword.emailSent":
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Email with further instructions was sent to your inbox."
                    type="success"
                />
            );
        case "forgotPassword.userNotFound":
            return (
                <Notification
                    identifier={identifier}
                    title="Warning"
                    text="Sorry, we don't have a user with that email address in the database. Have you made a mistake?"
                    type="warning"
                />
            );
        case "forgotPassword.emailSendError":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="Something went wrong, please refresh the page and try again."
                    type="error"
                />
            );
        case "confirmForgotPassword.passwordChanged":
            return (
                <Notification
                    identifier={identifier}
                    title="New Password Successfully Saved"
                    text="Sign in Using Your New Password."
                    type="success"
                />
            );
        case "confirmForgotPassword.notFound":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="This token has been already used. Please start the process of resetting password from the start."
                    type="error"
                />
            );
        case "confirmForgotPassword.expiredResetToken":
            return (
                <Notification
                    identifier={identifier}
                    title="Warning"
                    text="Reset token has expired or has been already used! Please start the process of resetting password from the start."
                    type="warning"
                />
            );
        case "confirmForgotPassword.validationError":
            return (
                <Notification
                    identifier={identifier}
                    title="Warning"
                    text="The new password must differ from your previous password."
                    type="warning"
                />
            );
        // Registration
        case "account.create.successful":
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Account successfully created."
                    type="success"
                />
            );
        case "account.create.emailSent":
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Email with verification link was sent to your inbox."
                    type="success"
                    expire="3500"
                />
            );
        case "account.create.expiredResetToken":
            return (
                <Notification
                    identifier={identifier}
                    title="Warning"
                    text="Verify token has expired or email has already been verified."
                    type="warning"
                />
            );
        case "account.create.emailVerify.successful":
            return (
                <Notification
                    identifier={identifier}
                    title="Email Address Verified!"
                    text="You can continue with the process"
                    type="success"
                />
            );
        case "account.create.emailVerify.failed":
            return (
                <Notification
                    identifier={identifier}
                    title="Email Address Verification Failed!"
                    text="Verify token has expired or email has already been verified."
                    type="warning"
                />
            );
        case "account.create.company.successful":
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Organizer Info saved successfuly!"
                    type="success"
                />
            );
        case "account.create.company.failed":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="There was a problem with creating company."
                    type="error"
                />
            );
        default:
            return null;
    }
};

AuthNotifications.defaultProps = {
    identifier: null,
    code: null,
};

AuthNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
};

export default AuthNotifications;
